export const NEW_MAKER_WINDOW_DAYS = 30;

export function isNewMaker(createdAt?: string): boolean {
  if (!createdAt) return false;
  const createdTime = new Date(createdAt).getTime();
  if (Number.isNaN(createdTime)) return false;
  const daysSinceCreated = (Date.now() - createdTime) / (1000 * 60 * 60 * 24);
  return daysSinceCreated >= 0 && daysSinceCreated <= NEW_MAKER_WINDOW_DAYS;
}
